import parsePhoneNumberFromString from 'libphonenumber-js';

// NEOIQ-2427: extracted from the "Top-up for Agent" flow's own super-agent-topup.utils.ts so the
// Peer to Peer transfer flow (src/app/pages/send-money/...) can share the same display
// conventions instead of maintaining separate, drifted copies. maskNamePart/maskFullName in
// particular are a bug fix over Peer to Peer's original inline template expression
// (`'*'.repeat(name.length - 2)`), which throws a RangeError for names of length <= 2.

export function maskNamePart(namePart: string): string {
    return namePart?.length > 2 ? namePart[0] + '*'.repeat(namePart.length - 2) + namePart[namePart.length - 1] : namePart ?? '';
}

export function maskFullName(firstName: string, lastName: string): string {
    return `${maskNamePart(firstName)} ${maskNamePart(lastName)}`.trim();
}

export function formatPhoneNumber(mobile: string): string {
    if (!mobile) return '';
    try {
        return parsePhoneNumberFromString(mobile)?.formatInternational() ?? mobile;
    } catch {
        return mobile;
    }
}

// Currency-aware decimal convention used for wallet balance displays app-wide (USD: 2 decimals,
// everything else e.g. IQD: 3 decimals) — see neo-home.component.html for the original usage.
export function currencyDecimals(currency: string): string {
    return currency?.toUpperCase() === 'USD' ? '1.2-2' : '1.3-3';
}
